import React, { useEffect, useState } from "react";
import s from "./DetailSalpren.module.css";

//service
import masiveDistributionServices from "../../../../../api/delivery/masiveDistribution";

//assets
import { Currency, Number } from "../../../../../helpers/currencyConvert";
import Pager from "../../../../Shared/Pagination/Pagination";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

//materialUi
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Alert,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BallotIcon from "@mui/icons-material/Ballot";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

const cellStyles = {
  fontFamily: "Roboto, sans-serif",
  fontSize: ".9rem",
  fontWeight: "400",
  borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
};

const DetailSalpren = ({ detail, setDetail }) => {
  const { t } = useTranslation();
  const { textColor } = useSelector((state) => state.local);

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [openError, setOpenError] = useState(false);

  const [page, setPage] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [sort, setSort] = useState({
    criteria: "ASC",
    field: "agency",
  });

  const getDetailData = () => {
    setLoading(true);
    masiveDistributionServices
      .getSalpremDetail(page, pageSize, sort, detail?.data?.id)
      .then((res) => {
        setItems(res?.items?.content);
        setCategories(res?.categories);
        setTotalPages(res?.items?.totalPages);
        setLoading(false);
      })
      .catch(() => {
        setOpenError(true);
        setLoading(false);
      });
  };

  const handleSort = (item) => {
    setSort((prev) => ({
      criteria:
        prev.field === item
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: item,
    }));
  };

  useEffect(() => {
    getDetailData();
  }, [page, pageSize, sort]);

  return (
    <Grid container className={s.container}>
      <Grid item container xs={11} className={s.header}>
        <Grid item xs={1} lg={1}>
          <ArrowBackIcon
            sx={{ fontSize: "2rem", color: "primary.main", mr: 1 }}
            onClick={() => setDetail({ status: false, data: {} })}
            className={s.arrow}
          />
        </Grid>
        <Grid item xs={11} lg={11} className={s.titleContainer}>
          <BallotIcon sx={{ fontSize: "2rem", color: "primary.main", mr: 1 }} />
          <h4>{`${t("drawDetail")}: ${detail.data.emission}`}</h4>
        </Grid>
      </Grid>

      <Grid item xs={11} className={s.data}>
        {loading ? (
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            <CircularProgress size="2rem" />
          </Grid>
        ) : items?.length ? (
          <>
            <Accordion
              defaultExpanded={false}
              sx={{ mb: 5, borderRadius: "5px" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: textColor }} />}
                className={s.accordionSummary}
                sx={{ backgroundColor: "primary.main", color: textColor }}
              >
                <p>{t("categories")}</p>
              </AccordionSummary>

              <AccordionDetails className={s.accordionDetails}>
                <TableContainer className={s.tableContainer}>
                  <Table stickyHeader>
                    <TableHead className={s.head}>
                      <TableCell
                        sx={{
                          ...cellStyles,
                          color: textColor,
                          fontWeight: 500,
                          backgroundColor: "primary.main",
                        }}
                        align="center"
                      >
                        {t("prizeCategory")}
                      </TableCell>
                      <TableCell
                        sx={{
                          ...cellStyles,
                          color: textColor,
                          fontWeight: 500,
                          backgroundColor: "primary.main",
                        }}
                        align="center"
                      >
                        {t("categoryValue")}
                      </TableCell>
                      <TableCell
                        sx={{
                          ...cellStyles,
                          color: textColor,
                          fontWeight: 500,
                          backgroundColor: "primary.main",
                        }}
                        align="center"
                      >
                        {t("prizesPerCategory")}
                      </TableCell>
                      <TableCell
                        sx={{
                          ...cellStyles,
                          color: textColor,
                          fontWeight: 500,
                          backgroundColor: "primary.main",
                        }}
                        align="center"
                      >
                        {t("commissionsRate")}
                      </TableCell>
                    </TableHead>
                    <TableBody>
                      {categories.map((item, i) => {
                        return (
                          <React.Fragment key={i}>
                            <TableRow
                              sx={{
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              <TableCell
                                align="center"
                                sx={{ fontSize: "1.1rem" }}
                              >
                                {item.prizeCategory || "-"}
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{ fontSize: "1.1rem" }}
                              >
                                <Currency value={item.categoryValue} />
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{ fontSize: "1.1rem" }}
                              >
                                {item.prizeQuantiyiPerCategory}
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{ fontSize: "1.1rem" }}
                              >
                                <Number
                                  value={item.commissionPercentage}
                                  digits={2}
                                />
                                %
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>

            <Accordion
              defaultExpanded={true}
              sx={{ mb: 5, borderRadius: "5px" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: textColor }} />}
                className={s.accordionSummary}
                sx={{ backgroundColor: "primary.main", color: textColor }}
              >
                <p>{t("prizes")}</p>
              </AccordionSummary>

              <AccordionDetails className={s.accordionDetails}>
                <TableContainer className={s.tableContainer}>
                  <Table stickyHeader>
                    <TableHead className={s.head}>
                      <TableCell
                        sx={{
                          ...cellStyles,
                          color: textColor,
                          fontWeight: 500,
                          backgroundColor: "primary.main",
                        }}
                        align="center"
                        onClick={() => handleSort("agency")}
                      >
                        {`${t("agency")} ${sort.field === "agency" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      <TableCell
                        sx={{
                          ...cellStyles,
                          color: textColor,
                          fontWeight: 500,
                          backgroundColor: "primary.main",
                        }}
                        align="center"
                        onClick={() => handleSort("categoryId")}
                      >
                        {`${t("prizeCategory")} ${sort.field === "categoryId" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                      <TableCell
                        sx={{
                          ...cellStyles,
                          color: textColor,
                          fontWeight: 500,
                          backgroundColor: "primary.main",
                        }}
                        align="center"
                        onClick={() => handleSort("quantity")}
                      >
                        {`${t("quantity")} ${sort.field === "quantity" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                      </TableCell>
                    </TableHead>
                    <TableBody>
                      {items?.map((item, i) => {
                        return (
                          <React.Fragment key={i}>
                            <TableRow
                              sx={{
                                backgroundColor:
                                  i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                              }}
                            >
                              <TableCell
                                align="center"
                                sx={{ fontSize: "1.1rem" }}
                              >
                                {`${item.agency}-0` || "-"}
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{ fontSize: "1.1rem" }}
                              >
                                {item.categoryId}
                              </TableCell>
                              <TableCell
                                align="center"
                                sx={{ fontSize: "1.1rem" }}
                              >
                                {item.quantity}
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
          </>
        ) : (
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              fontSize: "1.5rem",
              fontWeight: 300,
            }}
          >
            {t("noResults")}
          </Grid>
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Pager
          pageSize={pageSize}
          setPageSize={setPageSize}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          pageCustom={pageCustom}
          setPageCustom={setPageCustom}
        />
      </Grid>
      <Snackbar
        open={openError}
        autoHideDuration={6000}
        onClose={() => setOpenError(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <Alert
          variant="filled"
          onClose={() => setOpenError(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("tryInOtherMoment")}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default DetailSalpren;
